'use client'

import { HugeiconsIcon } from '@hugeicons/react'
import { CommandIcon } from '@hugeicons-pro/core-stroke-rounded'

type ShortcutKey = 'I' | 'J' | 'K'

/** Label + ⌘/Ctrl-style hint using Hugeicons CommandIcon + key (for sidebar toggle tooltips). */
export function SidebarShortcutTooltip({
  label,
  shortcutKey,
}: {
  label: string
  shortcutKey: ShortcutKey
}) {
  return (
    <span className="inline-flex max-w-[240px] flex-wrap items-center gap-x-2 gap-y-1 font-normal">
      <span>{label}</span>
      <span className="inline-flex shrink-0 items-center gap-0.5 text-background opacity-95" aria-hidden>
        <HugeiconsIcon icon={CommandIcon} className="size-3 shrink-0" />
        <kbd className="rounded border border-background/30 bg-white/15 px-1 py-0.5 font-mono text-[10px] font-medium tabular-nums leading-none not-italic text-background">
          {shortcutKey}
        </kbd>
      </span>
    </span>
  )
}
